import { Injectable } from '@angular/core';
import { PromotionResult, WindowRef } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class PromotionAlertService {
  private readonly localStorageKey = 'shownPromotions';

  constructor(private winRef: WindowRef) {}

  processData(cartId: string, promotions: PromotionResult[] = []): void {
    const validPromotions = this.filterInvalidPromotions(promotions);

    this.setDataToLocalStorage(cartId, validPromotions);
  }

  private filterInvalidPromotions(promotions: PromotionResult[]): PromotionResult[] {
    return promotions.filter((p) => {
      if (!p.description || !p.promotion || !p.promotion.code) {
        return false;
      }

      return true;
    });
  }

  private setDataToLocalStorage(cartId: string, promotions: PromotionResult[]): void {
    const ls = this.winRef.nativeWindow.localStorage;

    if (!ls) {
      return;
    }

    ls.setItem(
      this.localStorageKey,
      JSON.stringify({
        cartId,
        items: promotions.map((p) => p.promotion.code),
      }),
    );
  }
}
